import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import Poster from '../../components/Poster/Poster';
import Queue from '../../components/Queue/Queue';
import MeetingsGQL from '../../graphql-operations/meetings.graphql';
import RoomGQL from '../../graphql-operations/rooms.graphql';
import RoomService from '../../services/room.service';
import ErrorHandlingService from '../../services/error-handling.service';

let IS_SUBSCRIPTION_SET = false; // Apollo Client makes new connections if a subscribeToMore callback exists within a nested query every time it re-renders; this flag will be used to prevents that

const Kiosk = ({ match }) => {
    return (
        <Query query={RoomGQL.ROOM_QUERY} variables={{ roomName: match.params.roomName }}>
        {roomQueryResponse => {
            if (roomQueryResponse.error) return ErrorHandlingService.handleException(roomQueryResponse.error);
            const room = RoomService.parseRoomConfigValues(roomQueryResponse.data.room);
            return !room || !room.id ? '' : (
            <Query query={MeetingsGQL.MEETINGS_QUERY} variables={{ roomName: match.params.roomName }}>
            {({ loading, error, data, subscribeToMore }) => {
                if (error) return ErrorHandlingService.handleException(error);
                if (!IS_SUBSCRIPTION_SET) {
                    IS_SUBSCRIPTION_SET = true;
                    subscribeToMore({
                        document: MeetingsGQL.MEETINGS_SUBSCRIPTION,
                        variables: { roomName: match.params.roomName, roomId: room.id },
                        updateQuery: (prev, { subscriptionData }) => {
                            if (!subscriptionData) return prev;
                            return Object.assign({}, prev, {
                                // meetings: [...subscriptionData.data.meetings, ...prev.meetings],
                                meetings: subscriptionData.data.meetings,
                            });
                        },
                    });
                }
                return (
                    <div className="grid-y medium-grid-frame">
                        <div className="grid-x medium-grid-frame">
                            <section className="cell small-12 medium-6">
                                <Poster room={room} isRoomLoading={roomQueryResponse.loading} />;
                            </section>
                            <section className="cell small-12 medium-6">
                                <Queue meetings={data.meetings} areMeetingsLoading={loading} />;
                            </section>
                        </div>
                    </div>
                );
            }}
            </Query>);
        }}
        </Query>
    );
};

export default Kiosk;

Kiosk.propTypes = {
    match: PropTypes.object,
};

Kiosk.defaultProps = {
    match: {},
};



// WEBPACK FOOTER //
// ./src/containers/Kiosk/Kiosk.jsx